<script setup lang="ts">
import { computed } from 'vue';
import { VBtn, VIcon, VTooltip } from 'vuetify/components';

export type PrimaryActionButtonProps = {
  text?: string;
  icon?: string;
  color?: 'success' | 'warning' | 'info' | 'error' | string;
  variant?: VBtn['$props']['variant'];
  elevation?: VBtn['$props']['elevation'];
  height?: VBtn['$props']['height'];
  tooltip?: string;
  iconAttrs?: VIcon['$props'];
  tooltipAttrs?: VTooltip['$props'];
};

defineEmits<{ click: [event: Event] }>();

const p = withDefaults(defineProps<PrimaryActionButtonProps>(), {
  iconAttrs: () => ({}),
  tooltipAttrs: () => ({}),
  tooltip: undefined,
  color: 'success',
  variant: 'flat',
  height: '32',
});

const computedElevation = computed(() => {
  if (p.elevation != null) return p.elevation;
  return p.variant === 'tonal' ? '0' : '1';
});

const iconBindings = computed<VIcon['$props']>(() => ({
  size: 12,
  icon: p.icon,
  start: Boolean(p.text),
  ...p.iconAttrs,
}));
</script>

<template>
  <VBtn :variant size="small" :height :elevation="computedElevation" min-width="0" :color @click="$emit('click', $event)">
    <slot name="icon" v-bind="iconBindings">
      <VIcon v-if="icon" v-bind="iconBindings" />
    </slot>

    {{ text }}

    <slot />

    <VTooltip v-if="tooltip" activator="parent" location="top" :text="tooltip" open-delay="250" v-bind="tooltipAttrs" class="tw:print:hidden" />
  </VBtn>
</template>
